/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const LengthUnit = {
    Angstrom: 'LengthUnit.Angstrom',
    AstronomicalUnit: 'LengthUnit.AstronomicalUnit',
    Centimeter: 'LengthUnit.Centimeter',
    Chain: 'LengthUnit.Chain',
    DataMile: 'LengthUnit.DataMile',
    Decameter: 'LengthUnit.Decameter',
    Decimeter: 'LengthUnit.Decimeter',
    DtpPica: 'LengthUnit.DtpPica',
    DtpPoint: 'LengthUnit.DtpPoint',
    Fathom: 'LengthUnit.Fathom',
    Foot: 'LengthUnit.Foot',
    Hand: 'LengthUnit.Hand',
    Hectometer: 'LengthUnit.Hectometer',
    Inch: 'LengthUnit.Inch',
    KilolightYear: 'LengthUnit.KilolightYear',
    Kilometer: 'LengthUnit.Kilometer',
    Kiloparsec: 'LengthUnit.Kiloparsec',
    LightYear: 'LengthUnit.LightYear',
    MegalightYear: 'LengthUnit.MegalightYear',
    Megaparsec: 'LengthUnit.Megaparsec',
    Meter: 'LengthUnit.Meter',
    Microinch: 'LengthUnit.Microinch',
    Micrometer: 'LengthUnit.Micrometer',
    Mil: 'LengthUnit.Mil',
    Mile: 'LengthUnit.Mile',
    Millimeter: 'LengthUnit.Millimeter',
    Nanometer: 'LengthUnit.Nanometer',
    NauticalMile: 'LengthUnit.NauticalMile',
    Parsec: 'LengthUnit.Parsec',
    PrinterPica: 'LengthUnit.PrinterPica',
    PrinterPoint: 'LengthUnit.PrinterPoint',
    Shackle: 'LengthUnit.Shackle',
    SolarRadius: 'LengthUnit.SolarRadius',
    Twip: 'LengthUnit.Twip',
    UsSurveyFoot: 'LengthUnit.UsSurveyFoot',
    Yard: 'LengthUnit.Yard',
    Kiloyard: 'LengthUnit.Kiloyard',
    Megameter: 'LengthUnit.Megameter',
    Picometer: 'LengthUnit.Picometer',
    Gigameter: 'LengthUnit.Gigameter',
    Kilofoot: 'LengthUnit.Kilofoot',
    Femtometer: 'LengthUnit.Femtometer'
} as const;
export type LengthUnit = typeof LengthUnit[keyof typeof LengthUnit];


export function LengthUnitFromJSON(json: any): LengthUnit {
    return LengthUnitFromJSONTyped(json, false);
}

export function LengthUnitFromJSONTyped(json: any, ignoreDiscriminator: boolean): LengthUnit {
    return json as LengthUnit;
}

export function LengthUnitToJSON(value?: LengthUnit | null): any {
    return value as any;
}

/**
 * Check if a given object implements the LengthUnit interface.
 */
 export function instanceOfLengthUnit(value: any): value is LengthUnit {
    return Object.values(LengthUnit).includes(value)
}

